// extracted by mini-css-extract-plugin
export default {"requests":"Requests_requests__dHsXK","splitter":"Requests_splitter__iSrpa"};